import { PopperProps } from '@mui/material';

import {
  Icons,
  SxProps,
  EntityAction,
  EntityActions,
  tokens,
} from '@cast/design-system';

import { useAbility } from '@cast/shared-ability-data-access';

import { FormMode } from '@cast/shared-rff-ui';

type Props = {
  formMode?: FormMode;
  onEdit?: () => void;
  onDelete?: () => void;
  sx?: SxProps;
  container?: PopperProps['container'];
};

export const AlertFormSubdrawerActions = ({
  formMode,
  onEdit,
  onDelete,
  sx,
  container,
}: Props) => {
  const showEditButton = formMode === 'view';

  const [cantEdit, cantDelete] = useAbility().cannotMany([
    ['update', 'OrganizationWebHooks'],
    ['delete', 'OrganizationWebHooks'],
  ]);

  return (
    <EntityActions
      triggerButtonProps={{
        disabled: cantEdit && cantDelete,
        sx,
      }}
      container={container}
      testId="alert-form-subdrawer-actions"
    >
      {showEditButton && (
        <EntityAction
          onClick={(e) => {
            e.stopPropagation();
            onEdit?.();
          }}
          disabled={cantEdit}
          startAdornment={
            <Icons.PencilSimpleLine
              color={tokens.theme.fg.structural.secondary}
            />
          }
        >
          Edit
        </EntityAction>
      )}
      <EntityAction
        onClick={(e) => {
          e.stopPropagation();
          onDelete?.();
        }}
        disabled={cantDelete}
        startAdornment={<Icons.TrashSimple />}
        disruptive
      >
        Delete
      </EntityAction>
    </EntityActions>
  );
};
